import script from "./MazdaWorkspaceHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./MazdaWorkspaceHeader.vue?vue&type=script&setup=true&lang=js"

import "./MazdaWorkspaceHeader.vue?vue&type=style&index=0&id=ebbe73a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebbe73a8"]])

export default __exports__